import React, { Component } from "react";
import { MDBRow, MDBCol, MDBContainer, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBTable, MDBTableHead, MDBTableBody, MDBDataTableV5 } from "mdbreact";
import news1_1 from "../assets/news/news1_1.jpg";
import news1_2 from "../assets/news/news1_2.jpg";
import news2_1 from "../assets/news/news2_1.jpg";
import news2_2 from "../assets/news/news2_2.jpg";
import news5 from "../assets/news/news5.png";
import MetaTags from "react-meta-tags";
import axios from "axios";

export default class News extends Component {

    constructor(props) {
        super(props);
        this.state = {
            datatable: [],
            news: [],
        }
    }

    componentDidMount() {
        // axios.get("https://git.kpru.ac.th/admission2017/administrator_new/show/"+this.props.match.params.param).then((res) => {
        if (this.props.match.params.param) {
            axios.get("https://admission.kpru.ac.th/admission2017/administrator_new/shownewsBee/" + this.props.match.params.param).then((res) => {
                this.setState({ news: res.data })
            })
        } else {
            axios.get("https://admission.kpru.ac.th/admission2017/administrator_new/shownewsBee/0").then((res) => {
                this.setState({ news: res.data })
            })
        }
        // // let rowsdata = []
        // // rowsdata[0]["name"] = <><li>คลิกเพื่อดู ประกาศการรับสมัครนักศึกษาเข้าศึกษาต่อหลักสูตรประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู รอบ 2 ประจำปีการศึกษา 2565 <a className="text-success" href="https://mua.kpru.ac.th/imagesbg/publishregister_kru_2565_rob2.pdf" target="_blank"><u><blink>อ่านต่อ</blink></u></a></li></>
        // this.setState({
        //     datatable:{
        //         columns: [
        //             {
        //                 label: "ข่าวประชาสัมพันธ์",
        //                 field: "name",
        //                 width: 150,
        //                 attributes: {
        //                   "aria-controls": "DataTable",
        //                   "aria-label": "Name",
        //                 },
        //               },
        //         ],
        //         rows: []
        //     }
        // })
    }

    render() {
        return (<>
            <MetaTags>
                <title>ข่าวประชาสัมพันธ์ของระบบรับสมัครมหาวิทยาลัยราชภัฏกำแพงเพชร</title>
                <meta name="description" content="ข่าวประชาสัมพันธ์ของระบบรับสมัครมหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University" />
                <meta property="og:title" content="ข่าวประชาสัมพันธ์ของระบบรับสมัครมหาวิทยาลัยราชภัฏกำแพงเพชร" />
                <meta property="og:image" content="../../public/favicon.ico" />
            </MetaTags>
            <br />
            <MDBContainer fluid >
                <MDBRow>
                    <MDBCol lg="1" md="1" sm="0"></MDBCol>
                    <MDBCol lg="10" md="10" sm="12">
                        <MDBCard>
                            <MDBCardBody>
                                <MDBCardTitle className="text-align">
                                    ข่าวประชาสัมพันธ์
                                </MDBCardTitle>
                                <MDBCardText>
                                    <div style={{ fontSize: "20px" }}>
                                        {this.props.match.params.param === "1" ? <>
                                            ระดับปริญญาตรี ภาคปกติ (กำแพงเพชรและแม่สอด)
                                        </> : <>
                                            {this.props.match.params.param === "2" ? <>
                                                ระดับปริญญาตรี ภาคกศ.บป. (กำแพงเพชรและแม่สอด)
                                            </> : <>
                                                {this.props.match.params.param === "3" || this.props.match.params.param === "4" ? <>
                                                    ระดับบัณฑิตศึกษา
                                                </> : <>
                                                    {this.props.match.params.param === "5" || this.props.match.params.param === "0"  ? <>
                                                        ระดับหลักสูตรประกาศนียบัตรบัณฑิต
                                                    </> : <></>}
                                                </>}
                                            </>}
                                        </>}
                                    </div>
                                    <MDBTable striped>
                                        <MDBTableHead>
                                            <tr>
                                                <th>ข่าวประชาสัมพันธ์</th>
                                            </tr>
                                        </MDBTableHead>
                                        <MDBTableBody>
                                            {this.state.news.map((data, index) => {
                                                return <tr>
                                                    <td><li>{data.NEWS_TITEL} ({data.datetime}) <a className="text-success" href={data.NEWS_FILE} target="_blank"><u><blink>อ่านต่อ</blink></u></a></li></td>
                                                </tr>
                                            })}
                                        </MDBTableBody>
                                    </MDBTable>

                                    {/* <MDBDataTableV5 hover entriesOptions={[10, 20, 50, 100]} entries={10} pagesAmount={5} data={this.state.datatable} /> */}

                                    {/* <div style={{fontSize: "20px"}}>
                                            ระดับปริญญาตรี ภาคปกติ (กำแพงเพชรและแม่สอด)
                                        </div>
                                        <img style={{ margin: "10px 0 5px 0"}} src={news1_1} width="100%"/>
                                        <img style={{ margin: "10px 0 10px 0"}} src={news1_2} width="100%"/>
                                        <div style={{fontSize: "20px"}}>
                                            ระดับปริญญาตรี ภาคกศ.บป. (กำแพงเพชรและแม่สอด)
                                        </div>
                                        <img style={{ margin: "10px 0 5px 0"}} src={news2_1} width="100%"/>
                                        <img style={{ margin: "10px 0 10px 0"}} src={news2_2} width="100%"/>
                                        <div style={{fontSize: "20px"}}>
                                            ระดับประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู
                                        </div>
                                        <img style={{ margin: "10px 0 10px 0"}} src={news5} width="100%"/> */}
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol lg="1" md="1" sm="0"></MDBCol>
                </MDBRow>
            </MDBContainer>
        </>)
    }
}